import axios from 'axios'
import store from '@/store'

const HTTP = axios.create({
  baseURL: process.env.GATEWAY_ENDPOINT
})

/*
* The interceptor here ensures that we check for the token in local storage every time a HTTP request is made
*/
HTTP.interceptors.request.use(
  async (config) => {
    const idTokenData = store.getters.idTokenData

    if (idTokenData) {
      var now = Math.floor(new Date().getTime() / 1000) // current time in seconds
      var exp = store.getters.idTokenData.exp // expiry time of current token in seconds
      var min = 60 // minimum time before expiry in seconds

      console.log('Token valid for another ' + Math.ceil((exp - min - now) / 60) + ' minutes')

      if (exp - min - now < 0) {
        console.log('refreshing token')
        await store.dispatch('REFRESH_TOKEN', store.state.auth.refresh_token)
      }
    }

    if (store.state.auth.token) {
      config.headers['Authorization'] = `Bearer ${store.state.auth.token.id_token}`
    }

    return config
  },

  (error) => {
    return Promise.reject(error)
  }
)

export default HTTP



// WEBPACK FOOTER //
// ./src/common/http.js